import { render, staticRenderFns } from "./DeleteContactWorksCouncilDialog.vue?vue&type=template&id=d6f88e12&"
import script from "./DeleteContactWorksCouncilDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteContactWorksCouncilDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports